import { Button, Table } from 'antd';
import { IServicePermissionsGroupItem } from '../../../../model';
import getFormatMessage from '../../../../locales/get-format-message';

interface IProps {
  readonly getGroupList: () => void;
  readonly loading: boolean;
  readonly groupList: IServicePermissionsGroupItem[] | [];
  readonly onEdit: (record: IServicePermissionsGroupItem) => void;
  readonly onDel: (record: IServicePermissionsGroupItem) => void;
}
export const GroupTable = (props: IProps) => {
  const renderDefaultOperate = (
    record: IServicePermissionsGroupItem,
    onEdit: (record: IServicePermissionsGroupItem) => void,
    onDel: (record: IServicePermissionsGroupItem) => void
  ): React.ReactNode => {
    return (
      <div>
        <Button
          className="ant-btn ant-btn-default gc-btn gc-btn-primary btn-admin is-small"
          onClick={() => onEdit(record)}
        >
          {getFormatMessage('edit')}
        </Button>
        <Button
          className="ant-btn ant-btn-primary ant-btn-sm ant-btn-dangerous btn-admin"
          style={{ marginLeft: '2px' }}
          onClick={() => onDel(record)}
        >
          {getFormatMessage('delete')}
        </Button>
      </div>
    );
  };

  const findChildren = (parentId: number) => {
    const children = props.groupList.filter(
      (item) => item.parentId === parentId
    );
    const newChildren: IServicePermissionsGroupItem[] = [];
    children.forEach((child) => {
      const children = findChildren(child.objectGroupId);
      newChildren.push({
        ...child,
        children: children.length === 0 ? null : children,
      });
    });
    return newChildren;
  };

  const getGroupTree = () => {
    const rootNodes = findChildren(0);
    return rootNodes || [];
  };

  const columns = [
    {
      title: getFormatMessage('parentId'),
      dataIndex: 'parentId',
      key: 'parentId',
    },
    {
      title: getFormatMessage('objectGroupId'),
      dataIndex: 'objectGroupId',
      key: 'objectGroupId',
    },
    {
      title: getFormatMessage('objectGroupName'),
      dataIndex: 'objectGroupName',
      key: 'objectGroupName',
    },
    // {
    //   title: getFormatMessage('children'),
    //   dataIndex: 'children',
    //   key: 'children',
    // },
    // {
    //   title: getFormatMessage('objects'),
    //   dataIndex: 'objects',
    //   key: 'objects',
    // },
    {
      title: getFormatMessage('operate'),
      key: 'action',
      width: 150,
      render: (_text: string, record: IServicePermissionsGroupItem) =>
        renderDefaultOperate(record, props.onEdit, props.onDel),
    },
  ];

  return (
    <Table
      rowKey="objectGroupId"
      className="object-table"
      loading={props.loading}
      dataSource={getGroupTree()}
      columns={columns}
      pagination={false}
    />
  );
};
